export default __webpack_public_path__ + "static/Discuss and act-f0005cd78d53560ba719f7bb48bbc7f1.jpg";